import useDashboardStore from "@/state/dashboard";
import useMetadataStore from "@/state/metadata";
import { useMemo } from "react";
import { shallow } from "zustand/shallow";

const usePrepareDataForTab345 = () => {
  const data = useDashboardStore(
    (state) => state.additionalState.dataForWidget1_1DashboardOup,
    shallow
  );
  const orgUnits = useMetadataStore((state) => state.oupOrgUnits, shallow);
  const ouGroups = useMetadataStore((state) => state.oupOrgUnitGroups, shallow);

  const listProvince = useMemo(() => {
    const foundPvGroup = ouGroups.find(({ id }) => id === "jblbYwuvO33");
    if (!foundPvGroup) return [];

    const ouConverted = orgUnits.reduce(
      (result, curr) => ({
        ...result,
        [curr.id]: curr,
      }),
      {}
    );

    const resultProvinces = foundPvGroup.organisationUnits.reduce(
      (result, curr) => {
        if (ouConverted[curr.id]) result.push(ouConverted[curr.id]);
        return result;
      },
      []
    );

    if (!resultProvinces?.length) return [];
    return resultProvinces;
  }, [ouGroups, orgUnits]);

  const teiData = useMemo(() => {
    if (!data?.length) return [[], []];
    const listTeiResult = data.map(({ orgUnit, attributes, programStages }) => {
      const convertedProgramStage = programStages.reduce(
        (stageValue, currentStage) => {
          const events =
            currentStage?.events?.map(({ dataElements, id, eventDate }) => {
              const dataValues = dataElements.reduce((result, currentDe) => {
                result[currentDe.id] = currentDe;
                return result;
              }, {});

              return { id, eventDate, dataValues };
            }) || [];

          stageValue[currentStage.id] = { events };
          return stageValue;
        },
        {}
      );

      const convertedAttributes = attributes.reduce(
        (result, currentAttribute) => {
          result[currentAttribute.id] = currentAttribute;

          return result;
        },
        {}
      );

      return {
        attributes: convertedAttributes,
        programStages: convertedProgramStage,
        orgUnit,
      };
    });

    return listTeiResult;
  }, [data]);

  return { teiData, listProvince };
};

export default usePrepareDataForTab345;
